import React from 'react'
import { propTypes } from 'react-bootstrap/esm/Image'
import { fromJSX, Widget } from "widgets-for-react"


export const loader = (firstTimeLoading: boolean): Widget<never> => fromJSX(() => (
  <Loader firstTimeLoading={firstTimeLoading}/>
))

export const Loader = (props: {firstTimeLoading: boolean}) => {
  if(props.firstTimeLoading)
    return (<></>)
  return (
  <div id="loader" className="loader">
    <div className="main main--loader">
      <div className="main__inner">
        <div className="page">
          <div className="page__inner">
            <div className="loader__content container--s gutter--m spacing--m">
              <p className="loader__text">Loading...</p>
              <p className="loader__extra text--xs">This website does not support Internet Explorer; we advice to use Microsoft Edge or another modern browser.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}
